import { render } from "./MastNotizen.vue?vue&type=template&id=2471e7b6&scoped=true&ts=true"
import script from "./MastNotizen.vue?vue&type=script&lang=ts"
export * from "./MastNotizen.vue?vue&type=script&lang=ts"

import "./MastNotizen.vue?vue&type=style&index=0&id=2471e7b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2471e7b6"]])

export default __exports__